import i18n from "@/plugins/i18n";
export default {
  browse: {
    table: {
      headers: [
        {
          text: i18n.t("model.prop.no"),
          value: "index",
          sortable: false,
          filterable: false,
        },
        {
          text: "Mochi Id",
          value: "playerMochiId",
        },
        {
          text: "Avatar",
          value: "avatar",
        },
         {
          text: "Level",
          value: "level",
        },
      ],
    },
  },
  read: {
    tabs: [
      {
        key: "Info",
        label: i18n.t("string.info"),
      },
    ],
    table: {
      headers: [
        {
          text: "Mochi Id",
          value: "mochiId",
        },
         {
          text: "Level",
          value: "level",
        },
        {
          text: i18n.t("model.prop.created"),
          value: "timestampCreated",
          filterable: false,
        },
        {
          text: i18n.t("model.prop.lastUpdated"),
          value: "timestampUpdated",
          filterable: false,
        },
      ],
    },
  },
  add: {
    fields: [
      {
        type: "string",
        key: "mochiId",
        name: "Mochi Id",
      }
    ],
    rules: {
      mochiId: [(v) => !!v || "Mochi Id is required"],
    },
  },
  edit: false,
  delete: true,
};
